import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HorizontalTimelineComponent} from "./horizontal-timeline.component";
@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [HorizontalTimelineComponent],

    exports: [HorizontalTimelineComponent]
})
export class HorizontalTimelineModule { }



// WEBPACK FOOTER //
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/shared/horizontal-timeline/horizontal-timeline.module.ts